import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';

import KDSRadioGroup from '@decisiv/ui-components/lib/components/RadioGroup';

const RadioGroup = ({ name, defaultValue = undefined, ...props }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) => (
        <KDSRadioGroup
          name={name}
          value={value}
          onClick={(e) => e.stopPropagation()}
          onChange={({ target }) => onChange(target.value)}
          warningMessage={errors[name]?.message?.toString()}
          {...props}
        />
      )}
    />
  );
};

RadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.bool,
  ]),
};

RadioGroup.defaultProps = {
  defaultValue: undefined,
};

export default RadioGroup;
